import script from "./BrushMapSelectColor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapSelectColor.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapSelectColor.vue?vue&type=style&index=0&id=5fd1d6da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd1d6da"]])

export default __exports__